<template>
    <div class="checkout px-0 pt-0 pt-sm-0 pb-0 mt-3">
        <v-row v-if="status === null">
            <v-col cols="12" md="7" class="py-0">
                <v-card class="pa-2 mb-8" flat tile>
                    <v-row no-gutters>
                        <v-col>
                            <back-button/>
                        </v-col>
                    </v-row>

                    <div class="px-6">
                        <div class="body-1 mt-3 mb-1 text-uppercase">
                            {{ $vuetify.lang.t('$vuetify.widgets.checkout.title') }}
                        </div>

                        <!-- shipping address radios -->


                        <template v-if="cartEntriesHavePhysicalOnes">

                            <div class="headline mb-3 font-weight-bold">
                                {{ $vuetify.lang.t('$vuetify.widgets.checkout.address_selection') }}
                            </div>

                            <v-alert v-if="disablePrivate" class="body-1 mb-2" type="error">
                                {{ $vuetify.lang.t('$vuetify.widgets.checkout.bulky_goods_hint') }}
                            </v-alert>

                            <v-radio-group v-model="shipping">
                                <v-radio :disabled="disablePrivate"
                                         color="white"
                                         value="private">
                                    <template slot="label">
                                        <div
                                            :class="{ 'white--text': !disablePrivate, 'secondary--text': disablePrivate }">
                                            <div class="subtitle-1 font-weight-bold my-1">
                                                {{ $vuetify.lang.t('$vuetify.widgets.checkout.private_address') }}:
                                            </div>
                                            <div class="body-1">
                                                {{ currentUser.first_name }}
                                                {{ currentUser.last_name }}
                                            </div>
                                            <div class="body-1">
                                            <span class="text--secondary">
                                                {{
                                                    $vuetify.lang.t('$vuetify.form_items.street')
                                                }} {{ $vuetify.lang.t('$vuetify.form_items.street_number') }}:
                                            </span>
                                                {{ currentUser.profile.private_address_street }}
                                                {{ currentUser.profile.private_address_number }}
                                            </div>
                                            <div class="body-1">
                                            <span class="text--secondary">
                                                {{ $vuetify.lang.t('$vuetify.form_items.zip_code') }}:
                                            </span>
                                                {{ currentUser.profile.private_address_zip }}
                                            </div>
                                            <div class="body-1">
                                            <span class="text--secondary">
                                                {{ $vuetify.lang.t('$vuetify.form_items.private_city') }}:
                                            </span>
                                                {{ currentUser.profile.private_address_city }}
                                            </div>
                                            <div class="body-1">
                                            <span
                                                :class="{ 'text--secondary': currentUser.profile.private_address_country, 'text--error': !currentUser.profile.private_address_country }">
                                                {{ $vuetify.lang.t('$vuetify.form_items.country') }}:
                                            </span>
                                                {{ currentUser.profile.private_address_country }}
                                            </div>
                                        </div>
                                    </template>
                                </v-radio>
                                <v-radio color="white"
                                         value="business">
                                    <template slot="label">
                                        <div class="white--text">
                                            <div class="subtitle-1 font-weight-bold my-1">
                                                {{ $vuetify.lang.t('$vuetify.widgets.checkout.business_address') }}:
                                            </div>
                                            <div class="body-1">
                                                {{ currentUser.company.name }}
                                            </div>
                                            <div class="body-1">
                                                {{ currentUser.first_name }}
                                                {{ currentUser.last_name }}
                                            </div>
                                            <div class="body-1">
                                            <span class="text--secondary">
                                                {{
                                                    $vuetify.lang.t('$vuetify.form_items.street')
                                                }} {{ $vuetify.lang.t('$vuetify.form_items.street_number') }}:
                                            </span>
                                                {{ currentUser.company.address_street }}
                                                {{ currentUser.company.address_number }}
                                            </div>
                                            <div class="body-1">
                                            <span class="text--secondary">
                                                {{ $vuetify.lang.t('$vuetify.form_items.zip_code') }}:
                                            </span>
                                                {{ currentUser.company.address_zip }}
                                            </div>
                                            <div class="body-1">
                                            <span class="text--secondary">
                                                {{ $vuetify.lang.t('$vuetify.form_items.business_city') }}:
                                            </span>
                                                {{ currentUser.company.address_city }}
                                            </div>
                                            <div class="body-1">
                                            <span class="text--secondary">
                                                {{ $vuetify.lang.t('$vuetify.form_items.country') }}:
                                            </span>
                                                {{ currentUser.company.country['country_code'] }}
                                            </div>
                                        </div>
                                    </template>
                                </v-radio>
                            </v-radio-group>

                        </template>


                        <template v-if="cartEntriesHaveDigitalOnes">

                            <div class="headline mt-3 mb-3 font-weight-bold">
                                {{ $vuetify.lang.t('$vuetify.widgets.checkout.email_selection') }}
                            </div>

                            <p class="body-1 mb-5">
                                {{ $vuetify.lang.t('$vuetify.widgets.checkout.email_selection_hint') }}
                            </p>

                            <v-radio-group v-model="shippingMail">
                                <v-radio color="white"
                                         :value="currentUser.email"
                                >
                                    <template slot="label">
                                        <div
                                            :class="{ 'white--text': !disablePrivate, 'secondary--text': disablePrivate }">
                                            <div class="subtitle-1 font-weight-bold my-1">
                                                {{ $vuetify.lang.t('$vuetify.widgets.checkout.private_address') }}:
                                            </div>
                                            <div class="body-1">
                                                {{ currentUser.email }}
                                            </div>

                                        </div>
                                    </template>
                                </v-radio>
                                <v-radio color="white"
                                         :value="currentUser.profile.business_email">
                                    <template slot="label">
                                        <div class="white--text">
                                            <div class="subtitle-1 font-weight-bold my-1">
                                                {{ $vuetify.lang.t('$vuetify.widgets.checkout.business_address') }}:
                                            </div>
                                            <div class="body-1">
                                                {{ currentUser.profile.business_email }}
                                            </div>

                                        </div>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </template>
                    </div>
                </v-card>
            </v-col>

            <v-col cols="12" md="5" class="py-0">
                <!-- overview -->
                <v-card class="pt-2 px-2 mb-2" flat tile v-if="cartEntries.length > 0">
                    <div v-for="item in cartEntries" :key="item.id">

                        <v-row no-gutters>
                            <v-col cols="auto">
                                <v-avatar size="53"
                                          tile
                                          class="mr-2">
                                    <v-img :src="productImageSrc(item.product)"></v-img>
                                </v-avatar>
                            </v-col>
                            <v-col>
                                <v-row no-gutters class="mb-2">
                                    <v-col cols="12" class="body-1 text-uppercase">
                                        {{ item.product.product_brand }}
                                    </v-col>
                                    <v-col class="body-1 font-weight-bold">
                                        {{ item.product.title }}
                                    </v-col>
                                    <v-col class="body-1 align-self-end text-right">
                                        <div>{{ item.quantity }}x{{ Number(item.product.price) }}
                                            {{ $vuetify.lang.t('$vuetify.points.short') }}
                                        </div>
                                        <div class="font-weight-bold">{{ item.quantity * item.product.price | number }}
                                            {{
                                                $vuetify.lang.t('$vuetify.points.short')
                                            }}
                                        </div>
                                    </v-col>
                                </v-row>

                            </v-col>
                        </v-row>
                    </div>

                </v-card>

                <cart-account-overview :in-cart-overview="true"
                                       :disabled="checkoutIsDisabled"
                                       :total="total"
                                       :user="currentUser"
                                       :shipping="shipping"
                                       :checkout="checkout"
                                       :has-digital-products="cartEntriesHaveDigitalOnes"
                                       :has-physical-products="cartEntriesHavePhysicalOnes"
                ></cart-account-overview>
            </v-col>
        </v-row>
        <v-row v-else-if="status === 200">
            <v-col cols="12">
                <v-card class="pt-3 px-7 pb-4 mt-3" flat tile>
                    <p class="body-1 font-weight-bold ma-0">
                        {{ $vuetify.lang.t('$vuetify.widgets.checkout.your_order') }}
                    </p>
                    <v-container class="text-center" mt-4 mb-4>
                        <v-icon color="success" large>
                            mdi-check-all
                        </v-icon>
                    </v-container>
                    <h1 class="headline font-weight-bold mb-2">
                        {{ $vuetify.lang.t('$vuetify.widgets.checkout.success_headline') }}
                    </h1>
                    <p class="body-1 mb-6">
                        {{ $vuetify.lang.t('$vuetify.widgets.checkout.success_desc') }}
                    </p>
                    <p class="body-1 font-weight-bold mb-1">
                        {{ $vuetify.lang.t('$vuetify.widgets.checkout.success_hint_headline') }}
                    </p>
                    <p class="body-1 mb-5">
                        {{ $vuetify.lang.t('$vuetify.widgets.checkout.success_hint_desc') }}
                    </p>
                    <v-btn color="primary"
                           block
                           :to="shopUrl">
                        {{ $vuetify.lang.t('$vuetify.buttons.back_to_shop') }}
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else-if="status !== 200 && status !== null">
            <v-col cols="12">
                <v-card class="pt-3 px-7 pb-4 mt-3" flat tile>
                    <p class="body-1 font-weight-bold ma-0">
                        {{ $vuetify.lang.t('$vuetify.widgets.checkout.your_order') }}
                    </p>
                    <v-container class="text-center" mt-4 mb-4>
                        <v-icon color="error" large>
                            mdi-close
                        </v-icon>
                    </v-container>
                    <h1 class="headline font-weight-bold mb-2">
                        {{ $vuetify.lang.t('$vuetify.widgets.checkout.error_headline') }}
                    </h1>
                    <p class="body-1 mb-0">
                        {{ $vuetify.lang.t('$vuetify.widgets.checkout.error_desc') }}
                    </p>
                    <ul class="mb-5">
                        <li v-for="error in errors" class="body-1">
                            {{ error }}
                        </li>
                    </ul>
                    <v-btn color="primary"
                           block
                           :to="cartUrl">
                        {{ $vuetify.lang.t('$vuetify.buttons.back_to_cart') }}
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
// Components
import BackButton                                               from '../../components/BackButton';
import HeadingSection                                           from '../../components/HeadingSection';
import CartItemCard                                             from '../../components/Cards/CartItem';
import CartAccountOverview                                      from '../../components/CartAccountOverview';
// Models
import Cart                                                     from '../../models/Cart';
import User                                                     from '../../models/User';
// Utils
import { LOADER_CART, LOADER_CHECKOUT, ROUTE_CART, ROUTE_SHOP } from '../../utils/constants';
// Utils
import { parseErrors, parseErrorStatus }                        from '../../utils/api';

export default {
    name:       'cart',
    components: {
        BackButton,
        HeadingSection,
        CartItemCard,
        CartAccountOverview,
    },
    data() {
        return {
            shipping:       null,
            errors:         {},
            status:         null,
            disablePrivate: false,
            shippingMail:   null
        };
    },
    methods:  {
        productImageSrc(product) {
            return product.images.length > 0 ? product.images[0].source : '//via.placeholder.com/150x150/a1a1a1/FF0000/?text=Fallback';
        },
        async checkout() {

            let checkout = null;
            try {
                checkout = await Cart.checkout(this.shipping, this.shippingMail);
            } catch (e) {
                this.errors = parseErrors(e);
                this.status = parseErrorStatus(e);
                window.scrollTo(0, 0);
                this.$wait.end(LOADER_CHECKOUT);
                return;
            }

            window.scrollTo(0, 0);
            this.$wait.end(LOADER_CHECKOUT);
            const { data } = checkout;
            this.status    = data.status;
            if (data.status === 200) {
                User.updateBalance(data.updated_balance);
                Cart.deleteAll();
            }
        },
    },
    computed: {
        isFetchingEntries() {
            return this.$wait.is(LOADER_CART);
        },
        // determines if the items includes measurement cargo
        cartEntriesHaveBulkyOnes() {
            return Cart.isBulky();
        },
        cartEntriesHaveDigitalOnes() {
            return Cart.isContainingDigitalProducts();
        },
        cartEntriesHavePhysicalOnes() {
            return Cart.isContainingPhysicalProducts();
        },
        cartEntries() {
            return Cart.getAll();
        },
        total() {
            return Cart.getTotal();
        },
        currentUser() {
            return User.getCurrent();
        },
        cartUrl() {
            return { name: ROUTE_CART }
        },
        shopUrl() {
            return { name: ROUTE_SHOP }
        },
        checkoutIsDisabled() {

            let disabled = true;

            if(this.cartEntriesHavePhysicalOnes && this.cartEntriesHaveDigitalOnes) {
                if(this.shipping && this.shippingMail) {
                    disabled = false;
                }
            }

            if(!this.cartEntriesHavePhysicalOnes && this.cartEntriesHaveDigitalOnes) {
                if(this.shippingMail) {
                    disabled = false;
                }
            }

            if(this.cartEntriesHavePhysicalOnes && !this.cartEntriesHaveDigitalOnes) {
                if(this.shipping) {
                    disabled = false;
                }
            }

            return disabled;
        }
    },
    mounted() {
        Cart.fetch();

        this.$nextTick(() => {
            if (this.cartEntriesHaveBulkyOnes && this.currentUser.company.country.country_code !== 'DE') {
                this.disablePrivate = true;
            }
            if (this.disablePrivate) {
                this.shipping = 'business';
            }

            if (!this.cartEntriesHavePhysicalOnes) {
                this.shipping = 'private';
            }
        });
    },
}
</script>
